<template>
  <div>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="headingPlant">Scale Weight</md-dialog-title>

      <md-dialog-content>
        <!--<form id="top" novalidate @submit.prevent="doSaveUser">-->
        <form id="top">  
          <div class="layoutScale">
            <div >
              <callingApiCenter class= "adjust" type="bar" :paths="['/api/w/fsi/WebSaveOutbound']"></callingApiCenter>
              <h3 v-if="scaleTimeWaring" class="ErrorMessage">Scale time is in {{warningMinutes}} minutes difference!</h3>
              <h3 v-if="scaleTimeError" class="ErrorMessage">Scale data expired. Please scale again!</h3>
              <h3 v-if="scaleMasterError" class="ErrorMessage">Scale master data has issue , please contact IT!</h3>
              <h3 v-if="netWeightNegError" class="ErrorMessage">Total net weight cannot less then 1!</h3>

              <md-card v-if="receivingWindows == '185' || receivingWindows == '187' || receivingWindows == '888'" :class="getValidationRadio('dataForm.scale')">
                <md-card-header>
                  <div class="md-title">FSI</div>
                </md-card-header>
                <md-card-content>
                  <md-radio v-model="dataForm.scale" value="1" @change="onSelect">FSI Scale 1</md-radio>
                  <md-radio v-model="dataForm.scale" value="2" @change="onSelect">FSI Scale 2</md-radio>
                  <md-radio v-model="dataForm.scale" value="0" @change="onSelect">Outside Scale</md-radio>
                </md-card-content>
              </md-card>

              <md-card v-if="receivingWindows == '186' || receivingWindows == '188' || receivingWindows == '201'" :class="getValidationRadio('dataForm.scale')">
                <md-card-header>
                  <div class="md-title">Wilmington</div>
                </md-card-header>
                <md-card-content>
                  <md-radio v-model="dataForm.scale" value="3" @change="onSelect">WIL Scale 3(Front)</md-radio>
                  <md-radio v-model="dataForm.scale" value="4" @change="onSelect">WIL Scale 4(Back)</md-radio>
                  <md-radio v-model="dataForm.scale" value="0" @change="onSelect">Outside Scale</md-radio>
                </md-card-content>
              </md-card>
            </div>
          </div>

          <!-- <div v-if="getPermission.acnit.view">CCR Log ID: {{ ccrLog.logId }} </div> -->

          <!-- <div v-if="getPermission.acnit.view">
            <div class="layoutPlantShort">CCR</div>
            <div class="layoutPlant" v-if="dataForm.containerNo == ccrLog.containerNo">Container#: <md-input v-model="ccrLog.containerNo" disabled/></div>
            <div class="layoutPlant" v-if="dataForm.containerNo != ccrLog.containerNo">Container#: <md-input class="ErrorMessage" v-model="ccrLog.containerNo" disabled/></div>
            <div class="layoutPlant" v-if="dataForm.chassisNo == ccrLog.chassisNo">Chassis#: <md-input v-model="ccrLog.chassisNo" disabled/></div>
            <div class="layoutPlant" v-if="dataForm.chassisNo != ccrLog.chassisNo">Chassis#: <md-input class="ErrorMessage" v-model="ccrLog.chassisNo" disabled/></div>
            <div class="layoutPlant" v-if="dataForm.ctnrType == ccrLog.containerType">CTN Type: <md-input v-model="ccrLog.containerType" disabled/></div>
            <div class="layoutPlant" v-if="dataForm.ctnrType != ccrLog.containerType">CTN Type: <md-input class="ErrorMessage" v-model="ccrLog.containerType" disabled/></div>  
          </div> -->

          <!-- <div v-if="getPermission.acnit.view">
            <div class="layoutPlantShort">In System</div>
            <div class="layoutPlant" v-if="mode!= 'SWR' "><md-input v-model="dataForm.containerNo" /></div>
            <div class="layoutPlant" v-if="mode== 'SWR' "><md-input v-model="dataForm.containerNo" disabled/></div>
            <div class="layoutPlant" v-if="mode!= 'SWR' "><md-input v-model="dataForm.chassisNo" /></div>
            <div class="layoutPlant" v-if="mode== 'SWR' "><md-input v-model="dataForm.chassisNo" disabled/></div>
            <div class="layoutPlant" v-if="mode!= 'SWR' "><md-input  v-model="dataForm.ctnrType" /></div>
            <div class="layoutPlant" v-if="mode== 'SWR' "><md-input v-model="dataForm.ctnrType" disabled/></div>
          </div> -->

          <div class="layoutPlantShort"> </div>

          <!-- <div v-if="getPermission.acnit.view">  
            <div class="layoutPlant2">Scale Date CCR : <md-input v-model="ccrLog.date" disabled/></div>
            <div class="layoutPlant2">Scale Time CCR: <md-input v-model="ccrLog.time" disabled/></div>
            <div class="layoutPlant2">Total Weight CCR: <md-input v-model="ccrLog.scaleWeight" disabled/></div>
          </div> -->
          <div>
            <!-- <div v-if="dataForm.scale != '0' && dataForm.scale != '4'" class="layoutPlant2">Scale Date: <md-input v-model="item.date" disabled/></div> -->
            <!-- <div v-if="dataForm.scale == '0' || dataForm.scale == '4'" class="layoutPlant2">Scale Date: <md-input v-model="item.date" /></div> -->
            <!-- <div v-if="dataForm.scale != '0' && dataForm.scale != '4'" class="layoutPlant2">Scale Time: <md-input v-model="item.time" disabled/></div> -->
            <!-- <div v-if="dataForm.scale == '0' || dataForm.scale == '4'" class="layoutPlant2">Scale Time: <md-input v-model="item.time" /></div> -->
            <!-- <div class="layoutPlant2">Total Weight: <md-input v-model="item.nw"/></div> -->
            <!-- <div v-if="dataForm.scale != '0' && dataForm.scale != '4'" class="layoutPlant2">Total Weight: <md-input v-model="item.nw" @keyup="chkGWMinMax(item)" disabled/></div> -->
            <!-- <div v-if="dataForm.scale == '0' || dataForm.scale == '4'" class="layoutPlant2">Total Weight: <md-input v-model="item.nw" @keyup="chkGWMinMax(item)" /></div> -->
          
            <div class="layoutPlant2">Scale Date: <md-input v-model="item.date" :disabled="!getScaleControl(this.dataForm.scale)"/></div>
            <div class="layoutPlant2">Scale Time: <md-input v-model="item.time" :disabled="!getScaleControl(this.dataForm.scale)"/></div>
            <div class="layoutPlant2">Total Weight: <md-input v-model="item.nw" @keyup="chkGWMinMax(item)" :disabled="!getScaleControl(this.dataForm.scale)"/></div>

          
          
          </div>


          <!-- <div v-if="getPermission.acnit.view" class="layoutPlantYGP">YG Plate#<md-input v-model="ccrLog.plateNo" disabled/></div> -->
          <div class="layoutAutoComplete">
            <auto-complete-master-data-select
              :class="getValidationClass('dataForm.ygNo')"
              :preparedOptions="getYgOption()"
              label="Yard Goat"
              :init-value="dataForm.ygNo"
              :on-item-changed="handleYgChanged">
            </auto-complete-master-data-select>
          </div>

          <div class="layoutPlantWide">
            Yard Goat Weight : {{ dataForm.ygWeight }}
          </div>

          <div class="layoutPlantWide">
            <h3>Total Weight : {{ dataForm.weight }}</h3>
          </div>
      
          <md-dialog-actions>
            <md-button class="md-raised custButton" @click="cancalAction">
              <span class="icons-center material-icons">cancel</span>Close
            </md-button>
            <md-button type="submit" class="md-raised custButton" @click="checkAndSelect()">
              <span class="icons-center material-icons">create</span>Select
            </md-button>
          </md-dialog-actions>

          <div class="alwaysShow">
            <div>
              <md-dialog-actions>
                <md-button class="md-raised custButton" @click="readAction(null)">
                  <span class="icons-center material-icons">autorenew</span>Refresh
                </md-button>
              </md-dialog-actions>
            </div>
          </div>

          <div class="minMaxMessage">
            <h3 v-if="scaleTwminmaxError" class="ErrorMessage">Tare weight out of range 13000 ~ 35000</h3>  
            <h3 v-if="scaleGwminmaxError" class="ErrorMessage">Gross weight out of range 60000 ~ 78000</h3>    
            <h3 v-if="scaleNwminmaxError" class="ErrorMessage">Net weight out of range 30000 ~ 50000</h3>    
            <h3 v-if="scaleWgtnummError" class="ErrorMessage">Total Weight is not a numeric!</h3>    
          </div>
          <confirm-alert ref="confirmAlert"></confirm-alert>

        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>

form {
  width: 820px;
  margin: 0;
}

.layoutScale {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  font-family: Roboto Slab;
  margin: auto;
}

.layoutPlantShort {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 15%;
  line-height: 1.5;
  color: black;
  background-color: rgb(167, 214, 241);
  display: inline-block;
  font-family: Roboto Slab;
  margin: auto;
}

.layoutPlantYGP {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 20%;
  line-height: 1.5;
  color: black;
  background-color: rgb(182, 237, 204);
  display: inline-block;
  font-family: Roboto Slab;
  margin: auto;
}


.layoutPlant {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 20%;
  line-height: 1.5;
  color: black;
  background-color: rgb(185, 218, 237);
  display: inline-block;
  font-family: Roboto Slab;
  margin: auto;
}

.layoutPlant2 {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 20%;
  line-height: 1.5;
  color: black;
  display: inline-block;
  background-color: rgb(246, 226, 219);
  font-family: Roboto Slab;
  margin: auto;
}
.layoutPlantWide {
  padding-left: 7px;
  width: 200px;
  color: black;
  font-family: Roboto Slab;
  margin : 0;
}

.layoutPlantWide  > h3{
  margin-bottom: 0;
}

.adjust{
  padding-top: 0;
  margin-top: 0;
}

.headingPlant {
  padding-top: 0;
  padding-left: 0;
  margin-bottom: 0;
  color: #3522af;
  line-height: 2;
  font-size: 24px;
  font-family: Roboto Slab;
  margin-left: 10px;
}

.md-card {
    width: 400px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }

.SpinnerAdj {
  margin-left: 30px;
}

.md-card-header {
  padding-bottom: 0;
  padding-top: 5px;
}

.layoutAutoComplete {
  width: 30%;
  padding-left: 5px;
  display: inline-block;
}

.ErrorMessage {
  color: #f14668 !important;
}


</style>
<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import dateFormat from "../utils/dateFormat";
import { minLength, required, maxLength } from "vuelidate/lib/validators";
// import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
import callingApiCenter from "./CallingApiCenter.vue";
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import moment from "moment";
import MasterDataDisplay from './MasterDataDisplay.vue';
import DatePicker from './DatePicker.vue';
import confirmAlert from './ConfirmAlert.vue'

// const getScaleControlSearch = () => ({
//     mode: "list",
//     appName: "SCALE"
//   });


const getInitialdataForm = () => ({
  seqNo: null,
  scale: null,
  yard: null,
  ygNo: null,
  ygWeight: null,
  weight: null,
  driverLP: null,
  containerNo: null,
  chassisNo: null,
  ctnrType: null,
  twYgWeight: null,
  receivingWindows: null,
});
        
const getInitItem = () => ({
  date: dateFormat.getLocalDateOnly(moment().toDate()),
  time: dateFormat.time(moment().toDate()),
  channel: null,
  tran: null,
  nw: null,
  tw: null,
  unit: null,
  type: null,
  driverLP: null,
  containerNo: null,
  chassisNo: null,
  ctnrType: null,
});

// const getInitCcrLog = () => ({
//   office: "LGB",
//   logId: null,
//   yard: null,
//   gateType: null,
//   gateNo: null,
//   statusType: null,
//   logDateTime: null,
//   plateNo: null,
//   plateImage: null,
//   containerNo: null,
//   containerType: null,
//   containerImage: null,
//   chassisNo: null,
//   chassisImage: null,
//   scaleWeight: null,
//   processType: null,
//   inboundShipment: null,
//   seqNo: null,
//   date: null,
//   time: null,
// });

const getInitSearchRequest = () => ({
  yard: null,
  gateType: "S",
  gateNo: null,
  statusType: null,
  logDateTime: {
    startDate: null,
    endDate: null
  },
  logStatus: null
});

export default {
  // components: { AutocompleteCcicLocationSelect, callingApiCenter, MasterDataDisplay, DatePicker, confirmAlert },
  components: { callingApiCenter, MasterDataDisplay, DatePicker, confirmAlert },
  mixins: [validationMixin],
  props: {
    mode: String,
    action: Function,
    recWindow: String,
  },
  
  data: () => ({
    showDialog: false,
    dataForm: getInitialdataForm(),
    item: getInitItem(),
    // scalecontrolSearch: getScaleControlSearch(),
    // scaleControl: [],
    load: null,
    scaleMaster: [],
    selected: null,
    receivingWindows: '',
    scaleTimeWaring: false,
    warningMinutes: '',
    scaleTimeError: false,
    scaleMasterError: false,
    netWeightNegError: false,
    scaleGwminmaxError: false,
    scaleTwminmaxError: false,
    scaleNwminmaxError: false,
    scaleWgtnummError: false,
    // ccrLog: getInitCcrLog(),
    // result: getInitCcrLog(),
    searchRequest: getInitSearchRequest(),
    needAlert: true,
    scale0: null, 
    scale1: null,
    scale2: null,
    scale3: null,
    scale4: null,

  }),

  watch: {

    "dataForm.ygWeight"() {
      if (this.mode == "STR") {
        if (this.item.nw != null) {
          const gross = Number(this.load.vgmWeight == null ? "0" :this.load.vgmWeight) - Number(this.load.gwYgWeight == null ? "0" :this.load.gwYgWeight)
          const tare = Number(this.item.nw) - Number(this.dataForm.ygWeight);
          this.dataForm.weight = (gross - tare).toString();
        }
      };

      if (this.mode == "SWR") {
        if (this.item.nw != null) {
          const gross = Number(this.item.nw) - Number(this.dataForm.ygWeight);
          const tare = Number(this.load.tareWeight) - Number(this.load.twYgWeight);
          this.dataForm.weight = (gross - tare).toString();
        }
      };
    },

    "item.nw"() {
      if (this.mode == "STR") {
          const gross = Number(this.load.vgmWeight == null ? "0" : this.load.vgmWeight) - Number(this.load.gwYgWeight == null ? "0" :this.load.gwYgWeight);
          const tare = Number(this.item.nw) - Number(this.dataForm.ygWeight); 
          this.dataForm.weight = (gross - tare).toString();
      };

      if (this.mode == "SWR") {
          const gross = Number(this.item.nw) - Number(this.dataForm.ygWeight);
          const tare = Number(this.load.tareWeight) - Number(this.load.twYgWeight);
          this.dataForm.weight = (gross - tare).toString();
      };

    },

  },

  computed: {
    ...mapGetters([
      "getMasterDataByGroup",
      "getMasterDataName",
      "getMasterDataAsSelectOptionByGroup",
      "getUserProfile",
      'getPermission',
      'getSaleOfficeMasterData',
    ]),

  },

   async mounted() {

  },

  validations: {
    dataForm: {
      scale: { required },
      ygNo: { required },
    }, 
  },

  methods: {
    async openDialog(existingUser, scale0, scale1, scale2, scale3, scale4) {
      this.scale0 = scale0;
      this.scale1 = scale1;
      this.scale2 = scale2;
      this.scale3 = scale3;
      this.scale4 = scale4;

      this.$store.commit("clearApiError");
      this.$v.dataForm.$reset();
      this.dataForm = getInitialdataForm();
      this.item = getInitItem();
      // this.ccrLog = getInitCcrLog();
      this.load = existingUser;
      console.log(this.scaleMaster);
      this.dataForm.office = existingUser.office;
      this.dataForm.yard = existingUser.yard;
      if (this.mode == "SWR") {
         this.dataForm.scale = this.load.gwStation;
         this.item.nw = this.convertDecToInt(this.load.vgmWeight);
         this.chkGWMinMax(this.item);
      }   
      if (this.mode == "STR") {
         this.dataForm.scale = this.load.twStation;
         this.item.nw = this.convertDecToInt(this.load.tareWeight);
         this.chkGWMinMax(this.item);
      } 
      this.dataForm.driverLP = existingUser.driverLP;
      this.dataForm.containerNo = existingUser.containerNo;
      this.dataForm.chassisNo = existingUser.chassisNo;
      this.dataForm.ctnrType = existingUser.ctnrType;
      this.receivingWindows = existingUser.receivingWindows;
      this.dataForm.seqNo = existingUser.seqNo;
      this.dataForm.tareWeight = existingUser.tareWeight;
      this.scaleTimeWaring = false;
      this.scaleTimeError = false;
      this.scaleMasterError = false;
      this.netWeightNegError = false;
      this.showDialog = true;
      this.needAlert = true;

      
    },

    getScaleControl(scale) {
      
      if ( scale == null )
      {
        return false;
      }

      if ( scale == "0")
      {
        if ( this.scale0.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale0.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2))
          {
            return true;
          }
          else
          {
            return false;
          }
        }
        
      }

      if ( scale == "1")
      {
        if ( this.scale1.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale1.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2))
          {true
            return true;
          }
          else
          {
            return false;
          }
        }
      }

      if ( scale == "2")
      {
        if ( this.scale2.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale2.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2) )
          {
            return true;
          }
          else
          {
            return false;
          }
        }
      }

      if ( scale == "3")
      {
        if ( this.scale3.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale3.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2))
          {
            return true;
          }
          else
          {
            return false;
          }
        }
      }

      if ( scale == "4")
      {
        if ( this.scale4.status == "OFF" )
        { 
          return true;
        }
        else
        {
          const releaseDateDiff = moment().diff(this.scale4.releaseDate , 'minutes');
          if (releaseDateDiff < Number(2))
          {
            return true;
          }
          else
          {
            return false;
          }
        }
      }

    },


    convertDecToInt(val) {
       if (val) {
          console.log("convert: " + parseInt(val))
          return parseInt(val);
       } else {
          return val;
       }   
    },

    getValidationClass(fieldName) {
      const field = _(this.$v).lookup(fieldName);
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
      return {};
    },

    getValidationRadio(fieldName) {
      const field = _(this.$v).lookup(fieldName);
      if (field) {
        return {
          ErrorMessage: field.$invalid && field.$dirty,
        };
      }
      return {};
    },

    handleScaleChanged(id) {
      this.dataForm.scale = id;
    },

    handleYgChanged(id, tag, tag1, weight) {
      console.log(weight);
      this.dataForm.ygNo = id;
      this.dataForm.ygWeight = weight;
    },

    cancalAction() {
      this.showDialog = false;
      this.$store.commit("clearApiError");
    },

    readAction() {
      // if (this.dataForm.scale == '2'){
      //   this.getCCRLog(this.dataForm.scale);
      // }
      this.getScale(this.dataForm.scale);
    },


    getYgOption() {
       if (this.receivingWindows == '185' || this.receivingWindows == '187' || this.receivingWindows == '888')
       {
           return this.getMasterDataAsSelectOptionByGroup('YG_MASTER').filter( it => it.recWindow == '185');
       }
       else
       {
           return this.getMasterDataAsSelectOptionByGroup('YG_MASTER').filter( it => it.recWindow == '186');
       }
    },

    async getScale(scale) {
      this.item = getInitItem();
      if (scale == null) return;
      var url = "";
      const timeStamp = moment().unix()
      if (window.location.host == "localhost:8080") {
        switch (this.dataForm.scale) {
          case "1":
            url = "Alibi.csv?" + timeStamp;
            break;
          case "2":
            url = "Alibi2.csv?" + timeStamp;
            break;
          case "3":
            url = "Alibi.csv?" + timeStamp;
            break;
        }
      } else {
        switch (this.dataForm.scale) {
          case "1":
            url = "FSIScale/Alibi1.csv?" + timeStamp;
            break;
          case "2":
            url = "FSIScale/Alibi2.csv?" + timeStamp;
            break;
          case "3":
            url = "FSIScale/Alibi3.csv?" + timeStamp;
            break;
          // case "4":
          //   date = dateFormat.getLocalDateOnly(moment().toDate())
          //   time =  dateFormat.time(moment().toDate())
          //   break;
          // case "0":
          //   date = dateFormat.getLocalDateOnly(moment().toDate())
          //   time =  dateFormat.time(moment().toDate())
          //   break;
        }
      }
      $.get(url).then((data) => {
        const item = data.split("\n", 2);
        this.parseScale(item[1]);
      });
    },

    // async getCCRLog(scale) {
    //   this.ccrLog = getInitCcrLog();
    //   this.result = getInitCcrLog();

    //   if (scale == null) return;
    //   const scaleDate = dateFormat.getLocalDateOnly(moment().toDate())
    //   this.searchRequest.yard = this.receivingWindows;
    //   this.searchRequest.statusType = "S";
    //   this.searchRequest.gateNo = scale; 
    //   this.searchRequest.logDateTime.startDate = scaleDate + "T00:00:01";
    //   this.searchRequest.logDateTime.endDate = scaleDate + "T23:59:59";

    //   const search = this.searchRequest;

    //   if (scale != null )
    //   {
    //     this.result = await api.post('/api/w/ccr/data/getCCRLog', search);
    //     if ( this.result.length === 0) return;
    //     this.result.sort((a,b) => new Date(b.logDateTime) - new Date(a.logDateTime));
    //     this.ccrLog = this.result[0]
    //     this.ccrLog.date = moment(String(this.ccrLog.logDateTime)).format('YYYY/MM/DD')
    //     this.ccrLog.time = moment(String(this.ccrLog.logDateTime)).format('hh:mm:ss')
    //     const masterData = await api.post('/api/w/masterData',{groups:["YG_MASTER"]})
    //     const masterDataf = masterData.filter( it => it.tagId == this.ccrLog.plateNo)
    //     if ( masterDataf.length > 0 ){
    //       this.dataForm.ygWeight = masterDataf[0].weight
    //       this.dataForm.ygNo = masterDataf[0].tagId; 
    //     }
    //     else{
    //       this.dataForm.ygNo = " "
    //       this.dataForm.ygWeight = " "
    //     } 
    //   };
    // },

    chkGWMinMax(item) {
       //alert("check Gross Weight Min and Max: " + this.dataForm.nw);
       const wgt = (item.nw)? parseInt(item.nw) : item.nw;
       //console.log("chkGWMinMax " + wgt);
       //console.log("item: " + JSON.stringify(item));
       this.scaleGwminmaxError = false;
       this.scaleTwminmaxError = false;
       this.scaleNwminmaxError = false;
       this.scaleWgtnummError = false;
       const testdigit = /^[0-9]+$/.test(item.nw)
       //console.log("testdigit: " + testdigit);
       if (item.nw && item.nw != "" && !testdigit) { this.scaleWgtnummError = true; return;};
       if (this.mode == "SWR") { //gross wgt
          //console.log("mode: " + this.mode);
          if (item.nw && item.nw != ""
             && (wgt < 60000 || wgt > 78000)) {
              //alert("check Gross Weight Min and Max: " + wgt);
              this.scaleGwminmaxError = true;
          }

       } else { //tare wgt
         if (item.nw && item.nw != ""
             && (wgt < 13000 || wgt > 35000)) {
              //alert("check Tare Weight Min and Max: " + wgt);
              this.scaleTwminmaxError = true;
              const netwgt = parseInt(this.load.vgmWeight) - wgt;
              //console.log("netwgt: " + netwgt);
              if (netwgt < 30000 || netwgt > 50000 ) {
                this.scaleNwminmaxError = true;
              }
         }

       }
       //console.log("gwminmaxerr: " + this.scaleGwminmaxError + ", twminmaxerr: " + this.scaleTwminmaxError);
    },

    parseScale(item) {
      const info = item.split(",");
      if(this.dataForm.scale == "0" || this.dataForm.scale == "4"){
        const infoObject = {
                date: dateFormat.getLocalDateOnly(moment().toDate()),
                time:  dateFormat.time(moment().toDate()),
                nw: 0,
                tw: 0,
        };

        // if(this.receivingWindows == '185' || this.receivingWindows == '187'){
        //   this.dataForm.ygNo = "VYG185"
        // };
        // if(this.receivingWindows == '186' || this.receivingWindows == '188'){
        //   this.dataForm.ygNo = "VYG186"
        // };   
        // this.dataForm.ygWeight = 0
        this.scaleMasterError = false;
        this.scaleTimeWaring = false;
        this.scaleTimeError = false;
        this.warningMinutes = '';
        this.item = infoObject;
      }
      else{
        const infoObject = {
          date: info[0].split(" ")[0],
          time: info[0].split(" ")[1],
          channel: info[1],
          tran: info[2],
          nw: info[3],
          tw: info[4],
          unit: info[5],
          type: info[6],
        };
        this.item = infoObject;
        this.getScaleTimeControl();
      };

    },


    getScaleTimeControl()
    {
      this.scaleMaster = this.getMasterDataAsSelectOptionByGroup("SCALE_MASTER");
      this.scaleMasterError = false;
      const scaleItem = this.scaleMaster.filter( it => it.tagId == this.dataForm.scale); 
      
      if (scaleItem.length != 1) 
       {
        console.log(scaleItem);
        this.scaleMasterError = true;
        return
       }

       const scaleTime = moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time;
       const scaleTimeObject = moment(scaleTime);
       const diff = moment().diff(scaleTimeObject, 'minutes');
       if (diff > Number(scaleItem[0].errToleranceTime))
       {
         this.scaleTimeError = true;
       }
       else if (diff > Number(scaleItem[0].warnToleranceTime)){
         this.scaleTimeWaring = true;
         this.warningMinutes = scaleItem[0].warnToleranceTime;
       }
       else
       {
         this.scaleTimeWaring = false;
         this.scaleTimeError = false;
         this.warningMinutes = '';
       }
    },


    onSelect() {
      // console.log("test");
      // if (this.dataForm.scale != '2'){
      //     this.ccrLog.office = "LGB",
      //     this.ccrLog.logId = null,
      //     this.ccrLog.yard = null,
      //     this.ccrLog.gateType = null,
      //     this.ccrLog.gateNo = null,
      //     this.ccrLog.statusType = null,
      //     this.ccrLog.logDateTime = null,
      //     this.ccrLog.plateNo = null,
      //     this.ccrLog.plateImage = null,
      //     this.ccrLog.containerNo = null,
      //     this.ccrLog.containerType = null,
      //     this.ccrLog.containerImage = null,
      //     this.ccrLog.chassisNo = null,
      //     this.ccrLog.chassisImage = null,
      //     this.ccrLog.scaleWeight = null,
      //     this.ccrLog.processType = null,
      //     this.ccrLog.inboundShipment = null,
      //     this.ccrLog.seqNo = null,
      //     this.ccrLog.date = null,
      //     this.ccrLog.time = null
      // }
      
      this.getScaleControl(this.dataForm.scale);
      this.readAction();
    },

    async doConfirmAlert(message) {
      const ok = await this.$refs.confirmAlert.show({
         title: 'CONFRIM',
         message: message,
         okButton: 'Proceed',
         cancelButton: 'Revise',
      })      
      if (ok) {
         return 'OK';
      } else {
         return 'CANCEL';
      }
    },

    async checkAndSelect() {
      var gorevise = false;

      if (this.scaleTimeError) {
        window.alert('"Scale Data Expired! Re-Scale is required!')
        return;
      }

      if (this.scaleWgtnummError) {
         await this.doConfirmAlert("Total Weight is not a numeric, process with not select!").then ( (ret) =>{
          //console.log("retVal: " + JSON.stringify(ret));
          //this.needAlert = false;
          // if (ret == 'CANCEL') 
          //    gorevise = true;
          // if (ret == 'OK') {
          //   //alert("ret is OK");
          //   this.doSaveUser();
          // } else {
          //   //alert("ret is CANCEL");
          //   this.showDialog = true;
          // }
          if (ret == 'CANCEL') {
             this.showDialog = true;
             gorevise = true;
          }
         });
      }
      if (this.scaleGwminmaxError) {
         await this.doConfirmAlert("Gross weight out of range 60000 and 78000").then ( (ret) =>{
          //console.log("retVal: " + JSON.stringify(ret));
          //this.needAlert = false;
          // if (ret == 'CANCEL') 
          //    gorevise = true;
          // if (ret == 'OK') {
          //   //alert("ret is OK");
          //   this.doSaveUser();
          // } else {
          //   //alert("ret is CANCEL");
          //   this.showDialog = true;
          // }
          if (ret == 'CANCEL') {
             this.showDialog = true;
             gorevise = true;
          }
         });
      }
      if (this.scaleTwminmaxError) {
         var msg = "Tare weight out of range 13000 and 35000";
         if (this.scaleNwminmaxError) {
            msg += "; Net weight out of range 30000 and 50000";
         }
         await this.doConfirmAlert(msg).then ( (ret) =>{
          //console.log("retVal: " + JSON.stringify(ret));
          //this.needAlert = false;
          // if (ret == 'CANCEL') 
          //    gorevise = true; 
          // if (ret == 'OK') {
          //    this.doSaveUser();
          // } else {
          //    this.showDialog = true;
          // }
          if (ret == 'CANCEL') {
             this.showDialog = true;
             gorevise = true;
          }
         });
      }
      //console.log("showd: " + this.showDialog);
      if (!gorevise) {
        this.doSaveUser();
      }  
    },

    async doSaveUser() {
      this.$v.dataForm.$touch();
      console.log(JSON.stringify(this.dataForm));

      if (this.$v.dataForm.$invalid) {
        return;
      }
      
      if (this.item.nw == null || this.item.nw == 'NaN') return;
      console.log(this.item);


// //POC begin //
//       if (this.scaleTimeError) return

//       if (this.ccrLog.containerNo == "X" || this.ccrLog.containerNo == "0" ){
//           this.ccrLog.containerNo = this.dataForm.containerNo;
//       }
//       if (this.ccrLog.chassisNo == "X" || this.ccrLog.containerNo == "0" ){
//           this.ccrLog.chassisNo = this.dataForm.chassisNo;
//       }
//       if (this.ccrLog.containerType == "X" || this.ccrLog.containerNo == "0" ){
//           this.ccrLog.containerType = this.dataForm.ctnrType;
//       }

//       if (this.dataForm.containerNo == null){
//           this.dataForm.containerNo = this.ccrLog.containerNo;
//       }
//       if (this.dataForm.chassisNo == null){
//           this.dataForm.chassisNo = this.ccrLog.chassisNo;
//       }
//       if (this.dataForm.ctnrType == null){
//           this.dataForm.ctnrType = this.ccrLog.containerType;
//       }

//       if (this.ccrLog.containerNo !=this.dataForm.containerNo  ){
//           this.ccrLog.containerNo = this.dataForm.containerNo;
//         }
//       if (this.ccrLog.chassisNo != this.dataForm.chassisNo){
//           this.ccrLog.chassisNo = this.dataForm.chassisNo;
//         }
//       if (this.ccrLog.containerType != this.dataForm.ctnrType){
//           this.ccrLog.containerType = this.dataForm.ctnrType;
//         }
// //POC end //


      var selectDate = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + dateFormat.time(moment().toDate());
      const autoWeight = this.getScaleControl(this.dataForm.scale);
      if (!autoWeight)
        {
          selectDate = "0000-00-00T00:00:00";
        }


      if (this.mode == "STR") {
        // this.ccrLog.processType = "Container-20-Scale-Empty";
        console.log(moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time );
        this.load.twDate = moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time;
        this.load.tareWeight = this.item.nw;
        this.load.twYgNo = this.dataForm.ygNo;
        this.load.twYgWeight = this.dataForm.ygWeight;
        this.load.weight = this.dataForm.weight
        const seqNo = this.load.seqNo;
        const scale = this.dataForm.scale;

        //api
        //  .post("/api/w/fsi/WebSaveOutbound", {
          newAPIPost("/api/w/fsi/WebSaveOutbound", {
            mode: "OTW",
            user: this.load.user,
            username: this.getUserProfile.username,
            seqNo: seqNo,
            twDate: moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time,
            twDateWeb : selectDate,
            tareWeight: this.item.nw,
            twYgNo: this.dataForm.ygNo,
            twYgWeight: this.dataForm.ygWeight,
            weight: this.dataForm.weight,
            twStation: scale,
            driverLP: this.dataForm.ygNo,
            containerNo: this.dataForm.containerNo,
            chassisNo: this.dataForm.chassisNo,
            ctnrType: this.dataForm.ctnrType,
          })
          .then((ticket) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(seqNo, ticket, this.mode);
          });
      }

      if (this.mode == "SWR") {
        this.scaleMasterError = false;
        this.netWeightNegError = false;

        if (this.dataForm.weight < 1 )
        {
          this.netWeightNegError = true;
          return;
        }
        else{
          this.netWeightNegError = false;
        }

        // this.ccrLog.processType = "Container-30-Scale-Gross";
        console.log(moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time );
        this.load.gwDate = moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time;
        this.load.vgmWeight = this.item.nw;
        this.load.gwYgNo = this.dataForm.ygNo;
        this.load.gwYgWeight = this.dataForm.ygWeight;
        const seqNo = this.load.seqNo;
        const scale = this.dataForm.scale;
        //api
        //  .post("/api/w/fsi/WebSaveOutbound", {
        newAPIPost("/api/w/fsi/WebSaveOutbound", {
            mode: "OGW",
            user: this.load.user,
            username: this.getUserProfile.username,
            seqNo: seqNo,
            gwDate: moment(this.item.date, "YYYY/MM/DD").format("YYYY-MM-DD") + "T" + this.item.time,
            gwDateWeb: selectDate,
            vgmWeight: this.item.nw,
            gwYgNo: this.dataForm.ygNo,
            gwYgWeight: this.dataForm.ygWeight,
            gwStation: scale,
            weight: this.dataForm.weight,
          })
          .then((ticket) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(seqNo, ticket, this.mode);
          });
      }

// POC begin - Update CCR Log table from scale process //
      // if (this.dataForm.scale == "2"){
      //   this.ccrLog.seqNo = this.dataForm.seqNo;
      //   await api.post('/api/w/ccr/data/updateCCRLog', this.ccrLog);
      // }
// POC end //

    },
  },
};
</script>